import React from 'react';
import classNames from 'classnames';
import { ListingCard, PaginationLinks } from '../../../components';

import css from './SearchResultsPanel.module.css';
import { useEffect } from 'react';

const SearchResultsPanel = props => {
  const {
    className,
    rootClassName,
    listings = [],
    pagination,
    search,
    setActiveListing,
    isMapVariant = true,
    isServiceListingCard,
    isMobileLayout,
    bottomSheetOpen,
    setCurrentView,
  } = props;
  const classes = classNames(
    rootClassName || css.root,
    className
  );

  const paginationLinks =
    pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName="SearchPage"
        pageSearchParams={search}
        pagination={pagination}
      />
    ) : null;

  const cardRenderSizes = isMapVariant => {
    if (isMapVariant) {
      const panelMediumWidth = 50;
      const panelLargeWidth = 62.5;
      return [
        '(max-width: 767px) 100vw',
        `(max-width: 1023px) ${panelMediumWidth}vw`,
        `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
        `${panelLargeWidth / 3}vw`,
      ].join(', ');
    } else {
      const panelMediumWidth = 50;
      const panelLargeWidth = 62.5;
      return [
        '(max-width: 549px) 100vw',
        '(max-width: 767px) 50vw',
        `(max-width: 1439px) 26vw`,
        `(max-width: 1920px) 18vw`,
        `14vw`,
      ].join(', ');
    }
  };
  const renderListings = () => (
    <div className={css.bottomSheetContent}>
      <div className={isMapVariant ? css.listingCardsMapVariant : css.listingCards}>
        {listings.map(l => (
          <ListingCard
            className={css.listingCard}
            key={l.id.uuid}
            listing={l}
            renderSizes={cardRenderSizes(isMapVariant)}
            setActiveListing={setActiveListing}
            isServiceListingCard={isServiceListingCard}
          />
        ))}
        {props.children}
      </div>
    </div>
  );

  useEffect(() => {
    if (bottomSheetOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => (document.body.style.overflow = '');
  }, [bottomSheetOpen]);
  return (
    <div className={classes}>
      {renderListings()}
      {/* {isMobileLayout ? (
        <BottomSheet
          open={bottomSheetOpen}
          onDismiss={() => [props.setbottomSheetOpen(false),setCurrentView(ViewOptions.MAP)]} // <-- Add this line
          snapPoints={({ maxHeight }) => [maxHeight * 0.6, maxHeight]}
          expandOnContentDrag
          skipAnimations={true}
        >
          {renderListings()}
        </BottomSheet>
      ) : (
        renderListings()
      )} */}
      {!isMobileLayout && paginationLinks}
    </div>
  );
};

export default SearchResultsPanel;
